import 'date-format-lite'
import moment from "moment/moment";

export const formatDate = (dateString) => {

    if(!dateString) return '';

    var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
    ];

    const date = new Date(dateString);

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + ' ' + monthNames[monthIndex] + ' ' + year;
}

export const fromatDateAsValue = (date) => {
    console.log(date);
    return date.format(`YYYY-MM-DD`);
}

export const removeTime = (dt) => {
    var momentDate = moment(dt);
    if( momentDate.hour() === 12 )
        momentDate = momentDate.add(-12, 'h');
    return momentDate.utc().format()
}

export const isOnToday = (date) => {
    var today = moment();
    return date.year() === today.year() &&
        date.month() === today.month() &&
        date.date() === today.date()
}



// WEBPACK FOOTER //
// ./src/utils/date.js